import React from "react";
import { usePerfil } from "../../../contexts/pages/perfilContext";
import { Row, Column } from "../../global/grid";
import Alert from "../../global/alert";

const PageLevelAlert = () => {
    const { error } = usePerfil();

    if (error) {
        return (
            <Row mb={5}>
                <Column sm="12">
                    <Alert variant="danger" {...error}/>
                </Column>
            </Row>
        );
    }

    return <></>;
};

export default PageLevelAlert;
